import { CollabItem } from 'components/CollabItem'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { computed } from 'mobx'
import { TodoProps } from './Types'
import { ReplyItem } from 'components/CommentV2/ReplyItem/ReplyItem'
import { TodoItem } from './TodoItem/TodoItem'
import { NewReplyForm } from './NewReplyForm/NewReplyForm'
import { List } from 'components/CollabItem/List/List'

const Todo = observer(function Todo({ items, inCleanupMode = false }: TodoProps) {
  const rootStore = useRootStore()
  const [todo, ...comments] = items
  const isActive = computed(() => rootStore.todos.selected?.id === todo.id).get()
  const isHighlighted = computed(() => rootStore.todos.highlighted?.id === todo.id).get()

  const ref = useRef<HTMLDivElement>(null)
  const createReplyFormInputRef = useRef<HTMLTextAreaElement>(null)
  const collapsed = rootStore.todos?.selected?.id !== todo.id

  /* -------------------------------------------------------------------------------------------------
   * Mouse interactions
   * -----------------------------------------------------------------------------------------------*/

  const handleClick = () => {
    if (isActive) {
      return
    }
    rootStore.todos.select(todo.id)
    rootStore.todos.markAsRead(todo.id)
    setTimeout(() => {
      createReplyFormInputRef.current?.focus()
    }, 50)
  }

  const handleMouseOver = () => {
    if (isActive || isHighlighted) {
      return
    }
    rootStore.todos.highlight(todo.id)
  }

  const handleMouseLeave = () => {
    rootStore.todos.highlight(undefined)
  }

  const handleClickOutside = () => {
    if (isActive) {
      rootStore.todos.select(undefined)
    }
  }

  return (
    <CollabItem.Root
      isActive={isActive}
      isHighlighted={isHighlighted}
      onClick={handleClick}
      onClickOutside={handleClickOutside}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      ref={ref}
    >
      <List collapsed={collapsed} onToggle={handleClickOutside} itemId={todo.id}>
        <TodoItem todo={todo} inCleanupMode={inCleanupMode} hasReplies={comments.length > 0} />
        {comments.map((item) => (
          <ReplyItem key={item.id} comment={item} inCleanupMode={inCleanupMode} />
        ))}
      </List>
      <CollabItem.ReplyForm>
        <NewReplyForm item={todo} inputRef={createReplyFormInputRef} />
      </CollabItem.ReplyForm>
    </CollabItem.Root>
  )
})

export { Todo }
